import React, { Component } from "react";
import { connect } from "react-redux";
import "./AUTPriceTable.css"
import axios from "axios";
import { configuration } from "../../appConfig";
import pricesAUT from "./PricesAUT.json";
import Swal from "sweetalert2";
import Lightbox from "react-image-lightbox";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
import { reportAuthorized } from "../../redux/actions/reportAuthorized";

const Toast = Swal.mixin({
   toast: true,
   position: "top-end",
   showConfirmButton: false,
   timer: 3000,
});

function findWithAttr(array, attr, value) {
   for(var i = 0; i < array.length; i += 1) {
       if(array[i][attr] === value) {
           return i;
       }
   }
   return -1;
}

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export class AUTPriceTable extends Component {
   constructor(props) {
      super(props);
      this.state = {
         lang: "",
         words: {},
         data: {},
         Dents: [],
         loadedFirstTime: false,
         LAKPercentage: "",
         ALUPercentage: "",
         kt_percentage: "",
         PricePerHour : "",
         preparation: "",
         openLightBox: false,
         imageArr: [],
         imageArrDamage: [],
         currentImageIndex: 0,
         filteredImages: [],
         insuaranceProvider : {}
      };
   }

   componentDidMount = async () => {
      this.getLang();
      await this.getData();
      // await this.getFallbackDetails();
      await this.getScanImages();
   };

   getScanImages = async () => {
      const partnerId = localStorage.getItem("partnerId");
      const selectedFile = localStorage.getItem("selectedFile");
      try {
        const response = await axios.get(configuration.getScanImages, {
          params: {
            partnerId: partnerId,
            vin: selectedFile,
          },
        });
  
        if (response && response.data) {
          const { data } = response;
          const filterImages = (images, keyword) => {
            return images ? images.filter(image => image.includes(keyword)) : [];
        };
  
        const Left = [
            ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
            ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
            ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
            ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
        ];
  
        const right = [
            ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
            ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
            ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
            ...filterImages(data.RightBackFender || data.right, "RightBackFender")
        ];
  
          this.setState({
            imageArr: [
              ...data.Hood,
              ...data.Roof,
              ...data.RightRoofFrame,
              ...data.LeftRoofFrame,
              ...data.TrunkCover,
              ...data.Trunk,
              ...right,
              ...Left,
              
              
            ],
          });
          const LeftDamage = [
            ...filterImages(data.LeftFrontFender_damage , "LeftFrontFender"),
            ...filterImages(data.LeftFrontDoor_damage , "LeftFrontDoor"),
            ...filterImages(data.LeftBackDoor_damage , "LeftBackDoor"),
            ...filterImages(data.LeftBackFender_damage , "LeftBackFender")
        ];
  
        const rightDamage = [
            ...filterImages(data.RightFrontFender_damage , "RightFrontFender"),
            ...filterImages(data.RightFrontDoor_damage , "RightFrontDoor"),
            ...filterImages(data.RightBackDoor_damage , "RightBackDoor"),
            ...filterImages(data.RightBackFender_damage , "RightBackFender")
        ];
  
          this.setState({
            imageArrDamage: [
              ...data.Hood_damage,
              ...data.Roof_damage,
              ...data.RightRoofFrame_damage,
              ...data.LeftRoofFrame_damage,
              ...data.TrunkCover_damage,
              ...data.Trunk_damage,
              ...rightDamage,
              ...LeftDamage,
              
              
            ],
          });
        }
      } catch (error) {
        console.error("Error fetching scan images:", error);
      }
    };

   getLang = () => {
      const base_url = window.location.origin;
      axios.get(`${base_url}/lang.json`).then((res) => {
         let lang = localStorage.getItem("lang");
         this.setState({ lang: lang });
         this.setState({ words: res.data });
      });
   };

   lang = (word) => {
      const { lang, words } = this.state;
      return words[word] ? words[word][lang] : word;
   };

   static getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.lang !== prevState.lang) {
         return { lang: nextProps.lang };
      } else return null;
   }
   getFallbackDetails = async () => {
      const url =
          configuration.getFallbackDetails +
          `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await axios.get(url);
  
      function hexToRgb(hex) {
          if (!hex) return null;
  
          hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
          let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
          } : null;
      }
  
      let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
      let rgbaColor = "";
      if (rgbColor) {
          rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;
      }
  
      if (res.data.success !== false) {
         this.props.getSelectedPartnerId({
            duplicateSelectedPartnerId : res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
            isDuplicateVin : res.data.is_vin_duplicate
          })
          this.setState({
              ALUPercentage: res.data.alu || 0,
              LAKPercentage: res.data.lak || 0,
              kt_percentage: res.data.printed_form,
              PricePerHour: res.data.PricePerHour,
              PrimaryColor: res.data.primary_color || "#FF0000",
              SecondaryColor: res.data.secondary_color || "#000000",
              PrimaryTextColor: res.data.primary_text_color || "#000000",
              SecondaryTextColor: res.data.secondary_text_color || "#fff",
              rgbaColor: rgbaColor,
          });
      }
  };  

   getData = () => {
      const [partnerId, vin] = [
         localStorage.getItem("partnerId"),
         localStorage.getItem("selectedFile"),
      ];
      const url = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
      axios
         .get(url)
         .then((res) => {
            if (res.data) {
               this.props.reportAuthorized({
            Authorized : res.data.Authorized,
            DATReportAuthorized : res.data.DATReportAuthorized,
            MiniReportAuthorized : res.data.MiniReportAuthorized,
            FullReportAuthorized : res.data.FullReportAuthorized,
            DetailedReportAuthorized : res.data.DetailedReportAuthorized,
            AmericanReportAuthorized : res.data.AmericanReportAuthorized,
          })
               if (res.data.Client != "") {
                  this.getInsurenceClients()
                }
                this.getFallbackDetails();
               this.setState({
                  data: res.data,
                  preparation : res.data.Preparation ,
                  Dents: res.data.Dents.map((item) => {
                     const checked_item = {
                        ...item, "checked" : []
                     }
                  return  checked_item
                  }),
               },() => {
                  this.mergeTrunkAndTrunkCover(res.data.Dents);
                  let filteredArr = this.state.Dents.filter((item)=> {
                     if(item.TotalDents && item.TotalDents > 0){
                        return item
                     }
                  });
                  if(filteredArr.length < 5){
                     this.setState({
                        preparation: filteredArr.length * 0.2
                     })
                  }else{
                     this.setState({
                        preparation: 1
                     })
                  }
               });
            }
         })
         .catch((err) => {
         });
   };

   getInsurenceClients = async () => {
      const partnerId = localStorage.getItem("partnerId");
  
      if (partnerId) {
        const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      const response = await axios.post(url)
      if (response.data) {
        response.data.map((info)=>{
          if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() && this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
            this.setState({insuaranceProvider : info})
          }
        })
        }
      }
  };

   mergeTrunkAndTrunkCover = (dents) => {
      let trunkRow = dents[findWithAttr(dents, 'Part', 'Trunk')]
      dents.map((row) => {
         if(row.Part === 'TrunkCover') {
            row.A = (row.A ? row.A : 0) + (trunkRow.A  ? trunkRow.A  : 0)
            row.B = (row.B ? row.B : 0) + (trunkRow.B ? trunkRow.B : 0)
            row.C = (row.C ? row.C : 0) + (trunkRow.C ? trunkRow.C : 0)
            row.TotalDents = row.A + row.B + row.C;
            trunkRow.A = 0
            trunkRow.B = 0
            trunkRow.C = 0
            trunkRow.TotalDents = 0
         }
      });
      this.setState({
         Dents : dents
      });
   }

   handleChange = (e, i) => {
      const { name, value } = e.target;
      const {data,  Dents , ALUPercentage, LAKPercentage, kt_percentage, preparation} = this.state;
      var alu = parseFloat(ALUPercentage) /100
      var kt = parseFloat(LAKPercentage) /100
      var pp = parseFloat(kt_percentage) /100
      Dents[i][name] = Math.abs( value ? parseInt(value) : 0 );
      Dents[i]["TotalDents"] = Dents[i]["A"] + Dents[i]["B"] + Dents[i]["C"];
      // data["Preparation"] = parseFloat(preparation);
      Dents[i]["AW"] = this.getOriginalAW(Dents[i], i).toFixed(2) ;

      // Dents[i]["checked"].map((item) => {

      //    if(item == "Alu"){
      //       Dents[i]["alu_value"] = (Dents[i]["AW_Total"] * alu).toFixed(2)
      //       Dents[i]["AW_Total"] = (parseFloat(Dents[i]["alu_value"]) + parseFloat(Dents[i]["AW_Total"])).toFixed(2)
         
      //    }
      
      //    if(item === "Lak"){
      //       Dents[i]["lak_value"] = (Dents[i]["AW_Total"] * kt).toFixed(2)
      //       Dents[i]["AW_Total"] = (parseFloat(Dents[i]["lak_value"]) + parseFloat(Dents[i]["AW_Total"])).toFixed(2)
      //    }
         

      //   if(item === "Push2paint"){
      //       Dents[i]["pp_value"] = (Dents[i]["AW_Total"] * pp).toFixed(2)
      //       Dents[i]["AW_Total"] = (parseFloat(Dents[i]["AW_Total"]) - parseFloat(Dents[i]["pp_value"])).toFixed(2)
      //    }
      // })

      // this.setState({
      //    Dents,
      // },()=> {
      //    let filteredArr = this.state.Dents.filter((item)=> {
      //       if(item.TotalDents && item.TotalDents > 0){
      //          return item
      //       }
      //    })
      //    if(filteredArr.length < 5){
      //       this.setState({
      //          preparation: filteredArr.length * 0.2
      //       })
      //    }else{
      //       this.setState({
      //          preparation: 1
      //       })
      //    }
      // })
      this.setState({ Dents }, () => {
         this.updatePreparation();
      });
   };
   // handleChange = (e, i) => {
   //    const { name, value } = e.target;
   //    const { Dents, ALUPercentage, LAKPercentage, kt_percentage } = this.state;
   //    var alu = parseFloat(ALUPercentage) / 100;
   //    var kt = parseFloat(LAKPercentage) / 100;
   //    var pp = parseFloat(kt_percentage) / 100;
   
   //    // Update Dents values
   //    Dents[i][name] = Math.abs(value ? parseInt(value) : 0);
   //    Dents[i]["TotalDents"] = Dents[i]["A"] + Dents[i]["B"] + Dents[i]["C"];
   //    Dents[i]["AW"] = this.getOriginalAW(Dents[i], i).toFixed(2);
   
   //    this.setState({ Dents }, () => {
   //       this.updatePreparation();
   //    });
   // };
   
   plasticChange = (part, e, index, key) => {
      const { name } = e.target;
      const { Dents, data } = this.state;
   
      if (e.target.checked) {
         Dents[index]["TotalDents"] = 0;
      } else {
         Dents[index]["TotalDents"] = Dents[index]["A"] + Dents[index]["B"] + Dents[index]["C"];
      }
   
      Dents[index][key] = e.target.checked;
   
      this.setState({ Dents }, () => {
         this.updatePreparation();
      });
      // this.handleSave()
   };
   
   updatePreparation = () => {
      const { Dents } = this.state;
      let filteredArr = Dents.filter(item => item.TotalDents && item.TotalDents > 0);
   
      if (filteredArr.length < 5) {
         this.setState({
            preparation: filteredArr.length * 0.2
         });
      } else {
         this.setState({
            preparation: 1
         });
      }
   };
   

   change = (e, i, key) => {
      const { name, checked } = e.target;
      const { Dents , ALUPercentage, LAKPercentage, kt_percentage} = this.state;
      var alu = parseFloat(ALUPercentage) /100
      var kt = parseFloat(LAKPercentage) /100
      var pp = parseFloat(kt_percentage) /100
      Dents[i][name] = checked;

      // Dents[i]["AW"] = this.getAW(Dents[i]);

      // if(checked && !Dents[i]["checked"].includes(name)){
      //    Dents[i]["checked"].push(name)
      // }
      // else{
      //    Dents[i]["checked"] =  Dents[i]["checked"].filter(item => item !== name)
      // }
      // else{
      //    Dents[i]["checked"] =  Dents[i]["checked"].filter(item => item !== name)

      //    Dents[i]["checked"].map((item) => {

      //       if(item == "Alu"){
      //          Dents[i]["alu_value"] = (Dents[i]["AW_Total"] * alu).toFixed(2)
      //          Dents[i]["AW_Total"] = (parseFloat(Dents[i]["alu_value"]) + parseFloat(Dents[i]["AW_Total"])).toFixed(2)
            
      //       }
         
      //       if(item === "Lak"){
      //          Dents[i]["lak_value"] = (Dents[i]["AW_Total"] * kt).toFixed(2)
      //          Dents[i]["AW_Total"] = (parseFloat(Dents[i]["lak_value"]) + parseFloat(Dents[i]["AW_Total"])).toFixed(2)
      //       }
            
   
      //      if(item === "Push2paint"){
      //          Dents[i]["pp_value"] = (Dents[i]["AW_Total"] * pp).toFixed(2)
      //          Dents[i]["AW_Total"] = (parseFloat(Dents[i]["AW_Total"]) - parseFloat(Dents[i]["pp_value"])).toFixed(2)
      //       }
      //    })
      // }
      this.setState({
         Dents,
      });
      // this.setState({
      //    Dents,
      // },()=>
      //    this.handleSave());
      // this.setState({
      //    Dents,
      // },()=> 
      // this.getOriginalAW_1(Dents[i], name)
      // );
   };

   getMaxValueKey = (row) => {
      const { A, B, C } = row;
      let max= "";
      let maxValueKey = "";
      var obj = { A, B, C }
      var typeObj = {
         A: "L",
         B: "M",
         C: "S"
      }
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
          if (value > max) {
            max = value;
            maxValueKey = typeObj[key];
          }
        }
      }
      return maxValueKey
    };

   getOriginalAW_1 = (row, name) => {
     const { Dents , ALUPercentage, LAKPercentage, kt_percentage} = this.state;
     var alu = parseFloat(ALUPercentage) /100
     var kt = parseFloat(LAKPercentage) /100
     var pp = parseFloat(kt_percentage) /100

     let Dents_part =  Dents.map((obj) => {
      let newobj = {...obj}
         if(obj.Part === row.Part){
            if(name == "Alu"){
               if(row.Alu){
                  // newobj["alu_value"] = (row.AW_Total * 0.2).toFixed(2)
                  // newobj["alu_value"] = (row.AW_Total * alu).toFixed(2)
                  newobj["alu_value"] = (row.OriginalAw * alu).toFixed(2)
                  newobj["AW_Total"] = (parseFloat(newobj["alu_value"]) + parseFloat(obj["AW_Total"])).toFixed(2)
               }else{
                  newobj["alu_value"] = ""
                  newobj["AW_Total"] = (parseFloat(obj["AW_Total"]) - parseFloat(obj["alu_value"])).toFixed(2)
               }

            }else if(name == "Lak"){
               if(row.Lak){
                  // newobj["lak_value"] = (row.AW_Total * 0.2).toFixed(2)
                  // newobj["lak_value"] = (row.AW_Total * kt).toFixed(2)
                  newobj["lak_value"] = (row.OriginalAw * kt).toFixed(2)
                  newobj["AW_Total"] = (parseFloat(newobj["lak_value"]) + parseFloat(obj["AW_Total"])).toFixed(2)
               }else{
                  newobj["lak_value"] = ""
                  newobj["AW_Total"] = (parseFloat(obj["AW_Total"]) - parseFloat(obj["lak_value"])).toFixed(2)
               }

            }else if(name == "Push2paint"){
               if(row.Push2paint){
               // newobj["pp_value"] = (row.AW_Total * 0.5).toFixed(2)
                  // newobj["pp_value"] = (row.AW_Total * pp).toFixed(2)
                  newobj["pp_value"] = (row.OriginalAw * pp).toFixed(2)
                  newobj["AW_Total"] =  (parseFloat(obj["AW_Total"]) - parseFloat(newobj["pp_value"])).toFixed(2) 
               }else{
                  newobj["pp_value"] = ""
                  newobj["AW_Total"] = (parseFloat(obj["AW_Total"]) + parseFloat(obj["pp_value"])).toFixed(2)
               }
            }
        }
        return newobj
     })
     this.setState({
      Dents : Dents_part
     })
   }

    getOriginalAW = (row, i) => {
      const {Dents} = this.state;
      const { TotalDents, AvgDiaMm } = row;
      let originalAW = 0;
      function getMaxValue(a, b, c) {
         return Math.max(a, b, c);
       }
       const max_1 = Math.max(row.A, row.B, row.C);
      pricesAUT.map((obj) => {
         if (
            TotalDents >= obj.dents.min &&
            TotalDents <= obj.dents.max &&
            TotalDents > 0
         ) {
            // obj.size.map((e) => {
               if(max_1 == row.A){
                  row.OriginalAw = obj.size[0].aw;
                  originalAW = obj.size[0].aw;
               }else if(max_1 == row.B){
                  row.OriginalAw = obj.size[1].aw;
                  originalAW = obj.size[1].aw;
               }else if(max_1 == row.C){
                  row.OriginalAw = obj.size[2].aw;
                  originalAW = obj.size[2].aw;
               }
            }
      });
      return originalAW;
   };

   getTotalAw = () => {
      const { Dents } = this.state; 
      let total =
         Dents &&
         Dents.reduce((acc, num, i) => {
            if (
               num.Part !== "LeftFrontTyre" &&
               num.Part !== "LeftBackTyre" &&
               num.Part !== "RightFrontTyre" &&
               num.Part !== "RightBackTyre" &&
               num.Part !== "FrontBumper" &&
               num.Part !== "BackBumper" &&
               num.Part !== "Underbody" &&
               num.Part !== "Trunk" &&
               num.Part !== "Inside"
            ) {
               // let allpart_totalAW = parseFloat(num.AW_Total) ? parseFloat(num.AW_Total).toFixed(2) :"0"
               // return acc + parseFloat(allpart_totalAW)
               return acc + parseFloat((this.getAW(num, i).toFixed(2)));
            } else {
               return acc;
            }
         }, 0);
      return total;
   };
   // plasticChange = (part, e, index, key) => {
   //    const { name } = e.target;
   //    const { Dents, data } = this.state;
      
   //    let filteredArr = this.state.Dents.filter((item)=> {
   //       if(item.TotalDents && item.TotalDents > 0){
   //          return item
   //       }
   //    })
   //    if (e.target.checked) {
   //       if(filteredArr.length < 5){
   //          this.setState({
   //             preparation: filteredArr.length * 0.2
   //          })
   //       }else{
   //          this.setState({
   //             preparation: 1
   //          })
   //       }
   //      data["Dents"][index]["TotalDents"] = 0
   //    } else{
   //      data["Dents"][index]["TotalDents"] = data["Dents"][index]["A"] +data["Dents"][index]["B"] + data["Dents"][index]["C"]
   //    }
   //    data["Dents"][index][key] = e.target.checked;
   //    this.setState({ data }, () => {});
   //  };
   getTotaldents =() =>{
      const { Dents } = this.state; 
      let total =
         Dents &&
         Dents.reduce((acc, num, i) => {
            if (
               num.Part !== "LeftFrontTyre" &&
               num.Part !== "LeftBackTyre" &&
               num.Part !== "RightFrontTyre" &&
               num.Part !== "RightBackTyre" &&
               num.Part !== "FrontBumper" &&
               num.Part !== "BackBumper" &&
               num.Part !== "Underbody" &&
               num.Part !== "Trunk" &&
               num.Part !== "Inside"
            ) {
               let allpart_totalAW = parseFloat(num.TotalDents) ? parseFloat(num.TotalDents) :"0"
               return acc + parseFloat(allpart_totalAW)
            } else {
               return acc;
            }
         }, 0);
      return total;
   }
   getTotal_C = () =>{
      const { Dents } = this.state; 
      let total =
         Dents &&
         Dents.reduce((acc, num, i) => {
            if (
               num.Part !== "LeftFrontTyre" &&
               num.Part !== "LeftBackTyre" &&
               num.Part !== "RightFrontTyre" &&
               num.Part !== "RightBackTyre" &&
               num.Part !== "FrontBumper" &&
               num.Part !== "BackBumper" &&
               num.Part !== "Underbody" &&
               num.Part !== "Trunk" &&
               num.Part !== "Inside"
            ) {
               let allpart_totalAW =num.Plastic ? 0 :  parseFloat(num.C) ? parseFloat(num.C) :"0"
               return acc + parseFloat(allpart_totalAW)
            } else {
               return acc;
            }
         }, 0);
      return total;
   }
   getTotal_B = () =>{
      const { Dents } = this.state; 
      let total =
         Dents &&
         Dents.reduce((acc, num, i) => {
            if (
               num.Part !== "LeftFrontTyre" &&
               num.Part !== "LeftBackTyre" &&
               num.Part !== "RightFrontTyre" &&
               num.Part !== "RightBackTyre" &&
               num.Part !== "FrontBumper" &&
               num.Part !== "BackBumper" &&
               num.Part !== "Underbody" &&
               num.Part !== "Trunk" &&
               num.Part !== "Inside"
            ) {
               let allpart_totalAW =num.Plastic ? 0 :  parseFloat(num.B) ? parseFloat(num.B) :"0"
               return acc + parseFloat(allpart_totalAW)
            } else {
               return acc;
            }
         }, 0);
      return total;
   }
   getTotal_A = () =>{
      const { Dents } = this.state; 
      let total =
         Dents &&
         Dents.reduce((acc, num, i) => {
            if (
               num.Part !== "LeftFrontTyre" &&
               num.Part !== "LeftBackTyre" &&
               num.Part !== "RightFrontTyre" &&
               num.Part !== "RightBackTyre" &&
               num.Part !== "FrontBumper" &&
               num.Part !== "BackBumper" &&
               num.Part !== "Underbody" &&
               num.Part !== "Trunk" &&
               num.Part !== "Inside"
            ) {
               let allpart_totalAW = num.Plastic ? 0 : parseFloat(num.A) ? parseFloat(num.A) :"0"
               return acc + parseFloat(allpart_totalAW)
            } else {
               return acc;
            }
         }, 0);
      return total;
   }

   getAluLakAddedAW = (row, i) => {
      const { ALUPercentage, LAKPercentage ,kt_percentage , Dents} = this.state;
  
      let [finalAW, incPR] = [0, 0];
      let originalAW = this.getOriginalAW(row, i);
 
      let aluPr = parseFloat(ALUPercentage);
      let lakPr = parseFloat(LAKPercentage);
      let ktPr = parseFloat(kt_percentage);

      if (row.Alu && row.Push2paint && row.Lak) {
         incPR = aluPr - ktPr + lakPr;
      }else if (row.Alu && row.Push2paint) {
         incPR = aluPr - ktPr;
      }else if (row.Alu && row.Lak) {
         incPR = aluPr + lakPr;
      }else if (row.Push2paint && row.Lak) {
         incPR = lakPr - ktPr ;
      } else if (row.Alu) {
         incPR = aluPr;
      }else if (row.Push2paint) {
         incPR = -ktPr;
      }else if (row.Lak) {
         incPR = lakPr;
      } else {
         incPR = 0;
      }

      if (incPR !== 0) {

         finalAW =
            0 ||
            parseFloat(originalAW) + (parseFloat(originalAW) * incPR) / 100.0;
      } else {
         finalAW = originalAW;
      }
      return finalAW;
   };

   getAW = (row, i, isFormate) => {
      const { ALUPercentage, LAKPercentage ,kt_percentage , Dents} = this.state;
      let finalAW = this.getAluLakAddedAW(row, i);

      let aluPr = parseFloat(ALUPercentage);
      let lakPr = parseFloat(LAKPercentage);
      let ktPr = parseFloat(kt_percentage);

      row.AW = parseFloat(finalAW.toFixed(2));
    
      if (isFormate) {
         finalAW = this.formateAW(finalAW);
      }
      return finalAW;
   };

   formateAW = (aw) => {
      return aw ? aw.toFixed(2).replace(".", ",") : aw;
   };

   handleSave = () => {
      const {data, preparation, Dents} = this.state;
      
      let filteredArr = this.state.Dents.filter((item)=> {
         if(item.TotalDents && item.TotalDents > 0){
            return item
         }
      })
      if(filteredArr.length < 5){
         this.setState({
            preparation: filteredArr.length * 0.2
         })
      }else{
         this.setState({
            preparation: 1
         })
      }
      Dents.forEach((part) => {
         if (part.Plastic) {
           part.TotalDamages = 0;
           part.TotalDents = 0;
           part.A = 0;
           part.B = 0;
           part.C = 0;
           part.AddedCount = 0;
           part.OriginalAw = 0;
           part.AW = 0;
           part.Alu = false;
           part.Push2paint = false;
           part.Aus = false;
           part.Lak = false;
           part.vs = false;
           part.Fix = false;
         }
       });
       this.setState({ Dents });
       
      data["Dents"] = Dents;
      // data["TotalDentCount"] = this.getTotalDents(data.Dents);
      data["Preparation"] = parseFloat(preparation);
      // data.Dents.forEach((part) => {
      //    part.B = part.B ? this.round10(parseInt(part.B), 1) : 0;
      //    part.AvgDiaMm = part.B ? this.round10(parseInt(part.AvgDiaMm), 1) : 0;
      // });
      const url =
         configuration.PostEditorChanges +
         `?partnerId=${localStorage.getItem(
            "partnerId"
         )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!data.TabViewUpdated}`;

      axios.post(url, { ...data, IsPriceTableUpdated : true,PartnerID: localStorage.getItem("partnerId") }).then((res) => {
         Toast.fire({
            type: "success",
            title: "Data saved successfully",
         });
         this.getScanImages()
         setTimeout(() => {
            window.location.reload();
          }, 1000);
      });

   };

   // toggle = (partName, showImg, isPlastic) => {
   //    if (showImg) {
   //      const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
   //        const spiltUrl = image.split("/")[6];
   //        const part = isPlastic
   //          ? spiltUrl && spiltUrl.split("_")[0]
   //          : spiltUrl && spiltUrl.split("_")[1];
   //        return part === partName;
   //      });
   //      this.setState({
   //        modal: !this.state.modal,
   //        imgPartName: partName,
   //        currentImageIndex: 0,
   //        filteredImages: imageArr, 
   //      });
   //    } else {
   //      this.setState({
   //        modal: !this.state.modal,
   //      });
   //    }
   //  };

   toggle = (partName, showImg, isPlastic) => {
      if (showImg) {
         const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
          const reportInclude = spiltUrl && spiltUrl.includes("Report")
          const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
          return part === partName;
        });
        this.setState({
          modal: !this.state.modal,
          imgPartName: partName,
          currentImageIndex: 0,
          filteredImages: imageArr, 
        });
      } else {
        this.setState({
          modal: !this.state.modal,
        });
      }
    };
   handleFooterChange = (e) => {
      const { name, value } = e.target;
      if (name === "preparation") {
         this.setState({
            [name]: parseFloat(value) >= 1 ? 1.0 : value,
         });
      }
   };

   getSamllMaterial = () => {
      const {preparation, PricePerHour} = this.state;
      let totalAW = this.getTotalAw() + parseFloat(preparation);
      let SmallMaterial = totalAW * parseFloat(PricePerHour) * 0.02;
      if(SmallMaterial > 73 ){
         SmallMaterial = 73
      }
      return SmallMaterial;
   };

   getRepairCost = () => {
      const { preparation,PricePerHour } = this.state;
      let total =
         ((this.getTotalAw() + parseFloat(preparation)) * parseFloat(PricePerHour)) + this.getSamllMaterial();
      total = this.formateAW(total);
      return total;
   };
    
   render() { 
      const dynamic_Table_Colors = {
         '--table-even-color': this.state.rgbaColor || '#E8F3FF',
         '--table-header-color': this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || '#D80707',
         '--table-footer-color': this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || '#000',
         '--table-header-text-color': this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || '#000',
         '--table-footer-text-color': this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || '#fff',
      };
      const { isTabView } = this.props;
      const { Dents, loadedFirstTime, openLightBox, imgPartName, preparation, ALUPercentage,kt_percentage, LAKPercentage, data } = this.state;
      const [partnerId,vin] = [localStorage.getItem('partnerId'),localStorage.getItem('selectedFile')]
      const {Authorized} = this.state.data
      var order = [
         "Hood",
         "Roof",
         "TrunkCover",
         "LeftRoofFrame",
         "LeftFrontFender",
         "LeftFrontDoor",
         "LeftBackDoor",
         "LeftBackFender",
         "RightRoofFrame",
         "RightBackFender",
         "RightBackDoor",
         "RightFrontDoor",
         "RightFrontFender",
       ];
       
       Dents.sort(function(a, b) {
         // sort based on the index in order Dents
         return order.indexOf(a.Part) - order.indexOf(b.Part);
       })

      return (

         <div className={`new_austria_table_main all-price-table-wrapper  ${isTabView ?  "container-fluid" : "title-row-main container"}`}>
            <div className="row dns-price-table-row">
               <div className="col-12 p-0 d-flex justify-content-between">
                  <div className="row p-0">
                     <div className="col-lg-6 col-md-6 col-sm-6 p-0">
                        <h3 className="report-title"> {this.lang("Damage Description at")}</h3>
                     </div>
                     {isTabView && (
                        <div className="col-lg-6 col-md-6 col-sm-6 text-right p-0 end-position-btn">
                           <div className="d-flex align-items-center justify-content-end">
                              <button
                                 style={{
                                    backgroundColor: "#F20000",
                                    padding: "5px 10px",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                 }}
                                 onClick={this.handleSave}
                              >
                               {this.lang("Update Table")}
                              </button>
                           </div>
                        </div>
                     )}
                  </div>
               </div>
            </div>
            <div className={`row aut_price_table_wrapper  ${this.props.viewType === "TabView" ? "arrow_table_main_wrapper" : ""}`}>
               <div className="col-lg-12 p-0">
                 <div  className="table-responsive">
                 <table
                     width="100%"
                     className=" table table-responsive-lg  w-100 pb-2 pt-2"
                  >
                     <thead>
                        <tr width="100%">
                           <th
                           style={dynamic_Table_Colors}
                           className={`part-tr both-top-border text-left ${isTabView ?  "thead_bottom_border" : ""}`} 
                           width="15%" 
                           >
                              {this.lang("Parts")}
                           </th>
                           {
                              (partnerId == "demo-at" || partnerId == "demo-1-2" ) &&
                              <>
                          <th className="empty_row"></th>
                          <th style={dynamic_Table_Colors} className={`part-tr both-top-border text-left ${isTabView ?  "thead_bottom_border dark-gray-col" : ""}`}  width="10%">{this.lang("plastic")} </th>
                              </>
                           }
                             {isTabView && (
                              <>
                          <th className="empty_row"></th>
                           <th 
                           style={dynamic_Table_Colors}
                           className={`part-tr top-left-border text-left  min-width-130 ${isTabView ?  "thead_bottom_border light-gray-col" : ""}`} 
                           width="5%"
   
                           >
                            {this.lang("Light-at")}
                           </th>
                              </>
                             )}
                             {isTabView && (
                           <th 
                           style={dynamic_Table_Colors}
                           className={`part-tr text-left  min-width-130 ${isTabView ?  "thead_bottom_border light-gray-col" : ""}`} 
                           width="5%"
                           >
                              {this.lang("Medium")}
                           </th>
                             )}
                              {isTabView && (
                           <th 
                           style={dynamic_Table_Colors}
                           className={`part-tr text-left top-right-border  min-width-130 ${isTabView ?  "thead_bottom_border light-gray-col" : ""}`} 
                           width="5%"
                           >
                             {this.lang("Heavy")}
                           </th>
                              )}
                           <th className="empty_row"></th>
                           <th 
                           width="10%" 
                           style={dynamic_Table_Colors}
                           className={`part-tr both-top-border text-left ${isTabView ?  "thead_bottom_border green-col" : ""}`} 
                           >
                              {this.lang("Dent Count at")}
                           </th>
                           {!isTabView && (
                           <>
                              <th className="empty_row"></th>
                              <th 
                              style={dynamic_Table_Colors}
                              className="both-top-border"
                              width="10%"
                                                    
                              >
                              L(eicht) M(ittel) S(chwer)
                              </th>
                           </>
                           )}
                           <th className="empty_row"></th>
                           <th width="8%" 
                           style={dynamic_Table_Colors}
                           className={`part-tr top-left-border ${isTabView ?  "thead_bottom_border yellow-col" : ""}`} 
                           >
                             FIX
                           </th>
                           <th 
                           width={"8%"} 
                           style={dynamic_Table_Colors}
                           className={`part-tr ${isTabView ?  "thead_bottom_border orange-col" : ""}`} 
                           colSpan={isTabView ? "2" : "0"}
                           >
                               
                              {/* PP (-50%) */}
                              {this.lang("PP")}
                                 {kt_percentage
                                    ? ` (-${parseInt(
                                       kt_percentage
                                      )}%)`
                                    : "50%"}
                          
                           </th>
                           {/* KT(+20%) */}
                           <th 
                           width={"8%"} 
                           style={dynamic_Table_Colors}
                           className={`dents-tr ${isTabView ?  "thead_bottom_border dark-gray-col" : ""}`} 
                           colSpan={isTabView ? "2" : "0"}>
                             
                                 {/* KT (+20%) */}
                                 {this.lang("KT")}
                                 {LAKPercentage
                                    ? ` (+${parseInt(
                                         LAKPercentage
                                      )}%)`
                                    : "20%"}
                            
                           </th>
                           {/* ALU (+20%) */}
                           <th width={"8%"} 
                           style={dynamic_Table_Colors}
                           className={`dents-tr top-right-border ${isTabView ?  "thead_bottom_border orange-col" : ""}`} 
                           colSpan={isTabView ? "2" : "0"}
                           >
                             
                              {this.lang("ALU")}
                                 {ALUPercentage
                                    ?  ` (+${parseInt(
                                         ALUPercentage
                                      )}%)`
                                    : "20%"}
                             
                           </th>
                           <th className="empty_row"></th>
                           {/* VS */}
                           <th 
                           width={"8%"} 
                           style={dynamic_Table_Colors}
                           className={`dents-tr both-top-border ${isTabView ?  "thead_bottom_border light-gray-col" : ""}`} 
                           >
                            
                               {this.lang("VS")}
                            
                           </th>
                           {/* Ein/Aus bau */}
                           <th className="empty_row"></th>
                           <th 
                           width={"8%"} 
                           style={dynamic_Table_Colors}
                           className={`dents-tr both-top-border ${isTabView ?  "thead_bottom_border green-col" : ""}`} 
                           >
                              
                                 {this.lang("Ein/Aus bau")}
                             
                           </th>
                           <th className="empty_row"></th>
                           <th 
                           width={"10%"} 
                           style={{...dynamic_Table_Colors, minWidth:"100px"}}
                           className={`dents-tr both-top-border ${isTabView ?  "thead_bottom_border" : ""}`}
                           >
                            
                              {/* 1,0 AW = 1 Stunde */}
                              1,0 AW = <br/> 1 {this.lang("hour")}
                              
                           </th>

                        </tr>
                     </thead>

                     <tbody width="100%">
                     {Dents && Dents.length
                        ? Dents.map((row, i) => {
                        return (
                           row.Part !== "LeftFrontTyre" &&
                           row.Part !== "LeftBackTyre" &&
                           row.Part !== "RightFrontTyre" &&
                           row.Part !== "RightBackTyre" &&
                           row.Part !== "FrontBumper" &&
                           row.Part !== "BackBumper" &&
                           row.Part !== "Underbody" &&
                           row.Part !== "Trunk" &&
                           row.Part !== "Inside" && (
                              <>
                              <tr key={i}>
                                 <td 
                                   className="price-tbody-td"
                                   style={dynamic_Table_Colors}
                                 >
                                    {/* <p className="p-0 m-0 text-right" onClick={() => this.toggle(row.Part)} style={{cursor:"pointer", textDecoration : this.props.viewType === 'TabView' ? "underline" : ""}}> */}
                                    {isTabView ?
                                     <p className="p-0 m-0"
                                     onClick={() =>
                                       isTabView &&
                                       this.toggle(row.Part, true, row.Plastic)
                                     }
                                     >
                                       {this.lang(`${row.Part}-at`)}
                                    </p>
                                    :
                                    <p className="p-0 m-0 text-left">
                                     {this.lang(`${row.Part}-at`).split("(")[0]}
                                    </p>
                                    }
                                 </td>
                                 {
                              (partnerId == "demo-at" || partnerId == "demo-1-2" ) &&
                              <>
                          <td className="empty_row"></td>
                          <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td text-center fix_value_row ${isTabView ?  "dark-gray-col" : ""}`}
                                 >
                                    {isTabView ? 
                                    <input type='checkbox'
                                     className="cross_input"
                                     name="Plastic"
                                     checked={row.Plastic}
                                     disabled={Authorized}
                                     onChange={(e) => {
                                       this.plasticChange(
                                         row.Part,
                                         e,
                                         i,
                                         "Plastic"
                                       );
                                     }}
                                     id={i + "Plastic"}
                                    />
                                    
                                    :
                                    <input type='checkbox'
                                    className="cross_input"
                                    name="Plastic"
                                    disabled={Authorized}

                                    checked={row.Plastic}
                                    id={i + "Plastic"}
                                   />
                                    }
                                 </td>
                              </>
                           }
                                 {isTabView && (
                                 <>
                                    <td className="empty_row"></td>
                                    <td 
                                    style={dynamic_Table_Colors}
                                    className={`price-tbody-td input_row ${isTabView ?  "light-gray-col" : ""}`}
                                    >
                                    <div style={{ position: 'relative', width: '100%' }}>
                                       <input
                                          name="A"
                                          type='number'
                                          disabled={Authorized}

                                          min='0'
                                          value={row.Plastic ? 0 : row.A}
                                          onChange={(e) =>
                                             !row.Plastic &&
                                             this.handleChange(e, i)
                                          }
                                       />
                                       {!data.Authorized &&
                                      <>
                                       <div className="button-table-arrow-position">
                                       <button
                                         onClick={() => {
                                          const updatedValue = Math.max(row.A - 1, 0);
                                          this.handleChange({target: { name: 'A', value: updatedValue } }, i);
                                        }}
                                         disabled={row.Plastic}
                                         className="decrement-button"
                                       >
                                         -
                                       </button>
                                       <button
                                       onClick={() => {
                                          const updatedValue = row.A + 1;
                                          this.handleChange({ target: { name: 'A', value: updatedValue } }, i);
                                       }}
                                         disabled={row.Plastic}
                                         className="increment-button"
                                       >
                                         +
                                       </button>
                                       </div>
                                       </>
                                     }
                                       </div>
                                    </td>
                                 </>
                                 )}
                                 {isTabView && (
                                 <td 
                                    style={dynamic_Table_Colors}
                                    className={`text-center price-tbody-td input_row ${isTabView ?  "light-gray-col" : ""}`}
                                 >
                                    <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                       name="B"
                                       min='0'
                                     disabled={Authorized}

                                       type='number'
                                       value={row.Plastic ? 0 : row.B}
                                       onChange={(e) =>
                                          !row.Plastic &&
                                          this.handleChange(e, i)
                                       }
                                    />
                                    {!data.Authorized && 
                                      <>
                                       <div className="button-table-arrow-position">
                                       <button
                                         onClick={() => {
                                          const updatedValue = Math.max(row.B - 1, 0);
                                          this.handleChange({target: { name: 'B', value: updatedValue } }, i);
                                        }}
                                         disabled={row.Plastic}
                                         className="decrement-button"
                                       >
                                         -
                                       </button>
                                       <button
                                       onClick={() => {
                                          const updatedValue = row.B + 1;
                                          this.handleChange({ target: { name: 'B', value: updatedValue } }, i);
                                       }}
                                         disabled={row.Plastic}
                                         className="increment-button"
                                       >
                                         +
                                       </button>
                                       </div>
                                       </>
                                     }
                                    </div>
                                 </td>
                                 )}
                                 {isTabView && (
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td input_row ${isTabView ?  "light-gray-col" : ""}`}
                                 >
                                    <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                       name="C"
                                       min='0'
                                     disabled={Authorized}

                                       type='number'
                                       value={row.Plastic ? 0 : row.C}
                                       onChange={(e) =>
                                          !row.Plastic &&
                                          this.handleChange(e, i)
                                       }
                                    />
                                    {!data.Authorized && 
                                      <>
                                       <div className="button-table-arrow-position">
                                       <button
                                         onClick={() => {
                                          const updatedValue = Math.max(row.C - 1, 0);
                                          this.handleChange({target: { name: 'C', value: updatedValue } }, i);
                                        }}
                                         disabled={row.Plastic}
                                         className="decrement-button"
                                       >
                                         -
                                       </button>
                                       <button
                                       onClick={() => {
                                          const updatedValue = row.C + 1;
                                          this.handleChange({ target: { name: 'C', value: updatedValue } }, i);
                                       }}
                                         disabled={row.Plastic}
                                         className="increment-button"
                                       >
                                         +
                                       </button>
                                       </div>
                                       </>
                                     }
                                     </div>
                                 </td>
                                 )}
                                 <td className="empty_row"></td>
                                 {isTabView ?
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td input_row ${isTabView ?  "green-col" : ""}`}
                                 >
                                    <p className="p-0 m-0 text-center">
                                    {row.TotalDents}
                                    {row.Plastic ? "" : row.A || row.B || row.C ? ` (${this.getMaxValueKey(row)})` : ""}
                                    </p>
                                 </td>
                                 :
                                 <td
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td input_row ${isTabView ?  "light-gray-col" : ""}`}
                                 >
                                    <p className="p-0 m-0 text-center">
                                    {row.TotalDents}
                                    </p>
                                 </td>
                                 }
                                 {!isTabView && (
                                 <>
                                 <td className="empty_row"></td>
                                 <td
                                    style={dynamic_Table_Colors}
                                   className={`price-tbody-td input_row ${isTabView ?  "light-gray-col" : ""}`}
                                    >
                                    <p className="p-0 m-0 text-center">
                                    {row.TotalDents > 0 ?`${this.getMaxValueKey(row)}` : ""}
                                    </p>
                                 </td>
                                 </>
                                 )}
                                 <td className="empty_row"></td>
                                 {/* fix */}
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td text-center fix_value_row ${isTabView ?  "yellow-col" : ""}`}
                                 >
                                    {isTabView ? 
                                    <input type='checkbox'
                                    disabled={Authorized}

                                     className="cross_input"
                                     name="Fix"
                                     checked={row.Plastic ? false :row.Fix}
                                     onChange={(e) => !row.Plastic && this.change(e, i)}
                                     id={i + "Fix"}
                                    />
                                    :
                                    <input type='checkbox'
                                     className="cross_input round_border"
                                     name="Fix"
                                     checked={row.Fix}
                                     disabled={Authorized}

                                     id={i + "Fix"}
                                    />
                                    }
                                 </td>
                                 {/* Push2paint */}
                                 <td 
                                    style={dynamic_Table_Colors}
                                    className={`price-tbody-td text-center default_check_value ${isTabView ?  "orange-col" : ""}`}
                                    >
                                       {isTabView ? 
                                       <input 
                                       type='checkbox'
                                     disabled={Authorized}

                                       className="cross_input"
                                       name="Push2paint"
                                       checked={row.Plastic ? false :row.Push2paint}
                                       onChange={(e) => !row.Plastic && this.change(e, i)}
                                       id={i + "Push2paint"}
                                       />
                                       :
                                       <input 
                                       type='checkbox'
                                     disabled={Authorized}

                                       className="cross_input round_border"
                                       name="Push2paint"
                                       checked={row.Push2paint}
                                       id={i + "Push2paint"}
                                       />
                                       }
                                 </td>
                                 {isTabView && (
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td default_check_value ${isTabView ?  "orange-col" : ""}`}
                                 >
                                    <p className="p-0 m-0 text-center">
                                    {/* {row.pp_value} */}
                                    {row.Push2paint ?
                                    row.Plastic ? "" :
                                     this.formateAW(this.getOriginalAW(row) * kt_percentage / 100)
                                      :
                                      ""}
                                    </p>
                                 </td>
                                 )}
                                 {/* KT Lak*/}
                                 <td 
                                    style={dynamic_Table_Colors}
                                    className={`price-tbody-td text-center default_check_value ${isTabView ?  "dark-gray-col" : ""}`}
                                 >
                                    {isTabView ?
                                    <input
                                     type='checkbox'
                                     className="cross_input"
                                     disabled={Authorized}

                                     name="Lak"
                                     checked={row.Plastic ? false : row.Lak}
                                     onChange={(e) => !row.Plastic && this.change(e, i)}
                                     id={i + "Lak"}
                                    />
                                    :
                                    <input
                                    type='checkbox'
                                    className="cross_input round_border"
                                    name="Lak"
                                    disabled={Authorized}

                                    checked={row.Lak}
                                    id={i + "Lak"}
                                   />
                                    }
                                 </td>
                                 {isTabView && (
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td default_check_value ${isTabView ?  "dark-gray-col" : ""}`}
                                 >
                                    <p className="p-0 m-0 text-center">
                                    {/* {row.lak_value} */}
                                    {row.Lak ?
                                    row.Plastic ? "" :
                                      this.formateAW(this.getOriginalAW(row) * LAKPercentage / 100)
                                      :
                                      ""}
                                    </p>
                                 </td>
                                 )}
                                 {/* ALu */}
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td text-center default_check_value ${isTabView ?  "orange-col" : ""}`}
                                 >
                                 {isTabView ? 
                                 <input 
                                     type='checkbox'
                                     className="cross_input"
                                     name="Alu"
                                     disabled={Authorized}

                                     checked={row.Plastic ? false : row.Alu}
                                     onChange={(e) => !row.Plastic && this.change(e, i)}
                                     id={i + "Alu"}
                                    />
                                    :
                                    <input 
                                     type='checkbox'
                                     className="cross_input round_border"
                                     name="Alu"
                                     disabled={Authorized}

                                     checked={row.Alu}
                                     id={i + "Alu"}
                                 />
                                 }
                                 </td>
                                 
                                 {isTabView && (
                                 <td 
                                  style={dynamic_Table_Colors}
                                 className={`price-tbody-td default_check_value ${isTabView ?  "orange-col" : ""}`}
                                  >
                                    <p className="p-0 m-0 text-center">
                                       {/* {row.alu_value} */}
                                       {row.Alu ?
                                       row.Plastic ? "" : 
                                      this.formateAW(this.getOriginalAW(row) * ALUPercentage / 100)
                                      :
                                      ""}
                                    </p>
                                 </td>
                                 )}
                                 <td className="empty_row"></td>
                                 {/* pre-damage */}
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td text-center fix_value_row ${isTabView ?  "light-gray-col" : ""}`}
                                 >
                                    {isTabView ?
                                       <input type='checkbox'
                                       className="cross_input"
                                       name="vs"
                                     disabled={Authorized}

                                       checked={row.Plastic ? 0 : row.vs}
                                       onChange={(e) => !row.Plastic && this.change(e, i)}
                                       id={i + "vs"}
                                    />
                                    :
                                    <input type='checkbox'
                                       className="cross_input round_border"
                                       name="vs"
                                       checked={row.vs}
                                     disabled={Authorized}
                                       id={i + "vs"}
                                    />
                                    }
                                 </td>
                                 <td className="empty_row"></td>
                                 {/* Installation/removal(Ein/Aus bau) */}
                                 <td 
                                 style={dynamic_Table_Colors}
                                 className={`price-tbody-td text-center fix_value_row ${isTabView ?  "green-col" : ""}`}
                                 >
                                    {isTabView ?
                                      <input type='checkbox'
                                      className="cross_input"
                                     disabled={Authorized}

                                      name="Aus"
                                      checked={row.Plastic ? 0 : row.Aus}
                                      onChange={(e) => !row.Plastic && this.change(e, i)}
                                      id={i + "Aus"}
                                   />
                                   :
                                   <input type='checkbox'
                                   disabled={Authorized}

                                   className="cross_input round_border"
                                   name="Aus"
                                   checked={row.Aus}
                                   id={i + "Aus"}
                                  />
                                    }
                                    
                                 </td>
                                 <td className="empty_row"></td>
                                 {/* 1.0 AW = 1 hour */}
                                 <td
                                 className="price-tbody-td"
                                 style={dynamic_Table_Colors}
                                 >
                                    <p className="p-0 m-0 text-center">
                                       {/* {row.AW_Total?row.AW_Total:0 } */}
                                      {this.getAW(row, i, true)}
                                      {/* {row.AW} */}
                                    </p>
                                 </td>
                              </tr>
                              </>
                           )
                        );
                     })
                        : null
                     }
                     <tr className="last_border-total">
                        <td 
                        style={dynamic_Table_Colors}
                        className="tbody-last-td-wrapper both-bottom-border text-ledt"
                        >
                           {this.lang("Total")}
                        </td>
                        {
                           (partnerId == "demo-at" || partnerId == "demo-1-2" ) &&
                           <>
                           <td className="empty_row"></td>
                        <td 
                        style={dynamic_Table_Colors}
                        className={`tbody-last-td-wrapper both-bottom-border text-ledt  thead_top_border ${isTabView ?  "dark-gray-col" : ""}`}
                        >
                        </td>
                           </>
                        }
                        {isTabView && 
                        <>
                           <td className="empty_row"></td>
                           <td 
                           style={dynamic_Table_Colors}
                           className={`text-center tbody-last-td-wrapper bottom-left-border ${isTabView ?  "thead_top_border light-gray-col" : ""}`}
                           >
                              <strong>{(this.getTotal_A())}</strong>
                           </td>
                        </>
                        }
                       {isTabView && 
                       <td 
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-td-wrapper ${isTabView ?  "thead_top_border light-gray-col" : ""}`}
                        >
                           <strong>{(this.getTotal_B())}</strong>
                      </td>
                      }
                        {isTabView && 
                        <td 
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-td-wrapper bottom-right-border ${isTabView ?  "thead_top_border light-gray-col" : ""}`}
                        >
                          <strong>{(this.getTotal_C())}</strong>
                        </td>}
                        <td className="empty_row"></td>
                        <td 
                           style={dynamic_Table_Colors}
                           className={`text-center tbody-last-td-wrapper both-bottom-border ${isTabView ?  "thead_top_border green-col " : ""}`}
                        >
                        <strong>{(this.getTotaldents())}</strong>
                        </td>
                        <td className="empty_row"></td>
                        <td 
                        colSpan={isTabView ? "13" : "12"} 
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-td-wrapper both-bottom-border ${isTabView ?  "thead_top_border" : ""}`}
                        >
                        </td>
                      </tr>
                      <tr 
                      className="last_border_blank"
                     >
                        <td colSpan={20} >
                           
                        </td>
             
                      </tr>
                     </tbody>
            
                     <tfoot className="aut_table_footer">
                      <tr>
                        <td 
                        style={dynamic_Table_Colors}
                        className="first-aut-empty-td" 
                        colSpan={isTabView ? partnerId == "demo-at" ? "12" : "10" : partnerId == "demo-at" ? "10" : "8"} 
                        rowSpan="6"
                        >
                           {!isTabView && 
                           <>
                           <p>PP= Vordruck,</p>
                           <p>KT= Klebetechnik,</p>
                           <p> VS= Vorschaden</p>
   
                           </>
                           }
                        </td>
                        <td 
                        style={dynamic_Table_Colors}
                        colSpan={isTabView ? "9" : "6"}>
                           <p className="text-right">
                           {/* SUMME AW Reparatur */}
                           {this.lang("TOTALAWRepair")}
                           </p>
                        </td>
                        <td className="empty_row"></td>
                        <td style={dynamic_Table_Colors}>
                           <p className="p-0 m-0 text-right">
                           {/* <b>{this.getTotalAw().toFixed(2)}</b> */}
                            {this.formateAW(this.getTotalAw())}
                           </p>
                        </td>
                      </tr>
                      <tr>
                        <td style={dynamic_Table_Colors} colSpan={isTabView ? "9" : "6"}>
                           <p className="p-0 m-0 text-right">
                           {/* + AW Vorbereitung */}
                           {this.lang("+ AWPreparation")}
                           </p>
                        </td>
                        <td className="empty_row"></td>
                        <td style={dynamic_Table_Colors}>
                           <p className="p-0 m-0 text-right">
                             {this.formateAW(preparation)}
                           </p>
                        </td>
                      </tr>
                      <tr>
                        <td style={dynamic_Table_Colors} colSpan={isTabView ? "9" : "6"}>
                           <p className="p-0 m-0 text-right">
                           {/* SUMME AW GESAMT */}
                             {this.lang("TOTALAW")}
                           </p>
                        </td>
                        <td className="empty_row"></td>
                        <td style={dynamic_Table_Colors}>
                          <p className="p-0 m-0 text-right">
                             {/* {(this.getTotalAw() + parseFloat(preparation)).toFixed(2)} */}
                              {this.formateAW(this.getTotalAw() + parseFloat(preparation))}
                           </p>
                        </td>
                      </tr>
                      <tr>
                        <td style={dynamic_Table_Colors} colSpan={isTabView ? "9" : "6"}>
                           <p className="p-0 m-0 text-right">
                              {/* Verrechnungssatz €/Stunde */}
                              {this.lang("Chargerate/hour" )}
                           </p>
                        </td>
                        <td className="empty_row"></td>
                        <td style={dynamic_Table_Colors}>
                           <table className="w-100 aut_table_footer">
                          <tr>
                            <td className="p-0 text-left icon-td" style={{fontWeight: "normal",border:'none', fontSize:"14px; text-align:left;" }}>
                            <i className="fa fa-euro"></i>
                            </td>
                            <td style={{border : "none", padding: 0}}>
                            <p className="p-0 m-0 text-right">
                            {this.state.PricePerHour && this.state.PricePerHour.replace(".", ",") }
                           </p>
                            </td>
                          </tr>
                        </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={dynamic_Table_Colors} colSpan={isTabView ? "9" : "6"}>
                           <p className="p-0 m-0 text-right">
                           {/* + 2% Kleinmaterial */}
                           {this.lang("SmallMaterial-at")}
                           </p>
                        </td>
                        <td className="empty_row"></td>
                        <td style={dynamic_Table_Colors}>
                           <p className="p-0 m-0 text-right">
                            {this.formateAW(this.getSamllMaterial())}
                           </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="bottom-left-border" style={dynamic_Table_Colors} colSpan={isTabView ? "9" : "6"}>
                           <p className="p-0 m-0 text-right">
                           {/* Nettobetrag in € exkl. Mwst. */}
                             {this.lang("Netamount")}
                           </p>
                        </td>
                        <td className="empty_row"></td>
                        <td style={dynamic_Table_Colors} className="bottom-right-border">
                           <table className="w-100 aut_table_footer">
                           <tr>
                              <td className="p-0 m-0" style={{fontWeight: "normal",border:'none', fontSize:"14px", textAlign:"left !important" }}>
                                 <i className="fa fa-euro"></i>
                              </td>
                              <td style={{border : "none", padding: 0}}>
                              <p className="p-0 m-0 text-right">
                                 {this.getRepairCost()} 
                              </p>
                              </td>
                           </tr>
                           </table>    
                        </td>
                      </tr>
                     </tfoot>
                  </table>
                  {this.state.modal && (
              <Lightbox
                reactModalStyle={{
                  overlay: { zIndex: 100000000 },
                  content: {},
                }}
                mainSrc={
                  this.state.filteredImages.length > 0
                    ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                    : require("../../assets/img/brand/dashboard-error-logo.png")
                }
                imageCaption={this.state.filteredImages.length > 0 && this.lang(
                  this.state.filteredImages[this.state.currentImageIndex]
                    .split('/')
                    .pop()
                    .replace(/^Report_/, '')
                    .replace(/_\d+\.jpg$/, '')
                )}
                nextSrc={
                  `${this.state.filteredImages[
                    (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                  ]}?t=${new Date().getTime()}`
                }
                prevSrc={
                  `${this.state.filteredImages[
                    (this.state.currentImageIndex +
                      this.state.filteredImages.length -
                      1) % this.state.filteredImages.length
                  ]}?t=${new Date().getTime()}`
                }
                onCloseRequest={() => this.setState({ modal: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    currentImageIndex:
                      (this.state.currentImageIndex +
                        this.state.filteredImages.length -
                        1) %
                      this.state.filteredImages.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    currentImageIndex:
                      (this.state.currentImageIndex + 1) %
                      this.state.filteredImages.length,
                  })
                }
                onImageLoadError={(...events) => console.log(events)}
                imageLoadErrorMessage={
                  <img
                    style={{ height: "100%", width: "100%" }}
                    src={require("../../assets/img/brand/dashboard-error-logo.png")}
                  />
                }
              />
            )}
                 </div>
               </div>
            </div>
         </div>
      );
   }
}

const mapDispatchtoProps = (dispatch) => {
   return {
     getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
   };
 };
 const mapStateToProps = (props) => {
   return {
     lang: props.lang,
     toggleReportDamageImage : props.toggleReportDamageImage
   };
 };
 export default connect(mapStateToProps,mapDispatchtoProps)(AUTPriceTable);
